"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REVIEW_ACTION_CONFIRM_TITLE = exports.REVIEW_ACTION_CONFIRM_MESSAGE = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _models = require("@seedlang/models");
var _utils = require("@seedlang/utils");
var _review_due_helpers = require("./review_due_helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function cardIdsMatch(a, b) {
  if (a == null || b == null) {
    return false;
  }
  return String(a) === String(b);
}
var REVIEW_ACTION_CONFIRM_TITLE = exports.REVIEW_ACTION_CONFIRM_TITLE = {
  reset: 'Reset Review',
  snooze: 'Snooze Review',
  retire: 'Retire Review',
  "delete": 'Delete Review'
};
var REVIEW_ACTION_CONFIRM_MESSAGE = exports.REVIEW_ACTION_CONFIRM_MESSAGE = {
  reset: 'Are you sure that you want to reset this review? Your progress will be erased and it will become due today.',
  snooze: 'This will postpone the next review for this card. Continue?',
  retire: 'This review will be retired and hidden from your review decks unless you restore it. Continue?',
  "delete": 'Are you sure that you want to delete this review? This cannot be undone.'
};
var ReviewDetailsWrapper = function ReviewDetailsWrapper(Component) {
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  return (0, _mobxReact.observer)((_class = /*#__PURE__*/function (_React$Component) {
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _callSuper(this, _class, [props]);
      _initializerDefineProperty(_this, "showSpinner", _descriptor, _this);
      _initializerDefineProperty(_this, "showChartDetails", _descriptor2, _this);
      _initializerDefineProperty(_this, "forceReviewAfterDue", _descriptor3, _this);
      _initializerDefineProperty(_this, "showUpdatedCardTypeMessage", _descriptor4, _this);
      _initializerDefineProperty(_this, "retireReviewPending", _descriptor5, _this);
      _initializerDefineProperty(_this, "cardTypeName", _descriptor6, _this);
      _initializerDefineProperty(_this, "testReviewRows", _descriptor7, _this);
      _initializerDefineProperty(_this, "testCard", _descriptor8, _this);
      _initializerDefineProperty(_this, "intervalTesterReviewsDueAtBeginningOfDay", _descriptor9, _this);
      _this.afterGetCard = function (resp) {
        var _AppUI$cardStore$show;
        _state.AppUI.cardStore.setShowData(resp);
        _this.cardTypeName = (_AppUI$cardStore$show = _state.AppUI.cardStore.showData) === null || _AppUI$cardStore$show === void 0 ? void 0 : _AppUI$cardStore$show.cardTypeName;
        _this.resetIntervalTester();
        _this.retireReviewPending = false;
        _this.showSpinner = false;
      };
      _this.onSnoozeReview = function () {
        if (_this.cardId && !_this.props.overlayId) {
          _state.DeckUI.cardStore.snooze({
            ids: {
              cardId: _this.cardId
            }
          }, _this.loadCard);
        } else {
          _state.DeckUI.onSnoozeReview();
        }
      };
      _this.onResetReview = function () {
        _this.card.onResetReview();
        _this.resetIntervalTester();
        _state.DeckUI.updateSpacedRepetitionFields(_this.card);
        _state.AppUI.cardStore.destroyReviews({
          ids: {
            cardId: _this.cardId
          }
        }, _this.afterClearReviews);
      };
      _this.afterClearReviews = function () {
        _state.AppUI.reviewStore.clearIndexData();
      };
      _this.loadCard = function () {
        _state.AppUI.cardStore.getShow({
          ids: {
            cardId: _this.cardId
          }
        }, _this.afterGetCard);
      };
      _this.ensureCardLoaded = function () {
        var _AppUI$cardStore$show2;
        if (!_this.cardId) {
          _this.showSpinner = false;
          return;
        }
        var showDataMatches = cardIdsMatch((_AppUI$cardStore$show2 = _state.AppUI.cardStore.showData) === null || _AppUI$cardStore$show2 === void 0 ? void 0 : _AppUI$cardStore$show2.id, _this.cardId);
        if (!showDataMatches && !_this.hasLoadedIntervalTesterCard(_this.fallbackCard)) {
          _this.showSpinner = true;
          _this.loadCard();
        } else {
          _this.showSpinner = false;
        }
      };
      _this.onDeleteReview = function () {
        if (_this.cardId && !_this.props.overlayId) {
          _state.AppUI.cardStore.destroy({
            ids: {
              cardId: _this.cardId
            }
          }, _this.afterOnDeleteReview);
          _state.AppUI.user.set('reviewCardsCount', _state.AppUI.user.reviewCardsCount - 1);
        } else {
          _state.DeckUI.onDeleteReview();
        }
      };
      _this.afterOnDeleteReview = function () {
        if (_state.AppUI.layout.isNative) {
          _state.AppUI.cardStore.reloadIndexFiltered({
            queryStrings: {
              my_reviews: true
            }
          });
          _this.props.navigation.goBack();
        } else {
          _state.AppUI.routeStore.routeToNamed('reviews.index', {
            page: 1
          });
        }
      };
      _this.onRetireReview = function () {
        var _this$card, _AppUI$user, _this$card3;
        if (!_this.card || _this.retireReviewPending) {
          return;
        }
        var retired = Boolean((_this$card = _this.card) === null || _this$card === void 0 ? void 0 : _this$card.retired);
        var nextRetired = !retired;
        var previousRetiredCount = ((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.retiredCount) || 0;
        var restoreRetiredState = function restoreRetiredState() {
          var _this$card2;
          if ((_this$card2 = _this.card) !== null && _this$card2 !== void 0 && _this$card2.set) {
            _this.card.set('retired', retired);
          }
          if (_this.cardId && !_this.props.overlayId) {
            _state.AppUI.user.set('retiredCount', previousRetiredCount);
          }
          _this.retireReviewPending = false;
        };
        _this.retireReviewPending = true;
        if ((_this$card3 = _this.card) !== null && _this$card3 !== void 0 && _this$card3.set) {
          _this.card.set('retired', nextRetired);
        }
        if (retired) {
          var _this$card4;
          if (_this.cardId && !_this.props.overlayId) {
            _state.AppUI.user.set('retiredCount', Math.max(previousRetiredCount - 1, 0));
            _state.AppUI.cardStore.update({
              ids: {
                cardId: _this.cardId
              },
              data: {
                retired: false
              },
              failureCallback: restoreRetiredState,
              onRequestError: restoreRetiredState
            }, _this.loadCard);
          } else if ((_this$card4 = _this.card) !== null && _this$card4 !== void 0 && _this$card4.id) {
            _state.DeckUI.cardStore.update({
              ids: {
                cardId: _this.card.id
              },
              data: {
                retired: false
              },
              failureCallback: restoreRetiredState,
              onRequestError: restoreRetiredState
            }, function () {
              return _this.retireReviewPending = false;
            });
          } else {
            _this.retireReviewPending = false;
          }
        } else if (_this.cardId && !_this.props.overlayId) {
          _state.AppUI.user.set('retiredCount', previousRetiredCount + 1);
          _state.AppUI.cardStore.retire({
            ids: {
              cardId: _this.cardId
            },
            failureCallback: restoreRetiredState,
            onRequestError: restoreRetiredState
          }, _this.loadCard);
        } else {
          _state.DeckUI.onRetireReview();
          _this.retireReviewPending = false;
        }
      };
      _this.processScore = function (score) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!_this.testCard && _this.card) {
          _this.testCard = _this.simulationCard(_this.card);
        }
        if (!_this.testCard) {
          return;
        }
        _this.testCard.processScore(score, opts);
        _this.testReviewRows = [{
          id: "test-".concat(new Date().getTime()),
          repetitionInterval: _this.testCard.repetitionInterval,
          lastScore: _this.testCard.lastScore,
          lastScoreText: _this.scoreText(score),
          createdAtText: new _models.ReactiveDateDecorator(new Date(Date.now() + (opts.reviewTimeOffsetMs || 0))).formattedDateWithYear
        }].concat(_toConsumableArray(_this.testReviewRows));
      };
      _this.resetIntervalTester = function () {
        _this.testReviewRows = [];
        _this.testCard = _this.simulationCard(_this.card);
      };
      _this.scoreText = function (score) {
        if (score === _constants.Constants.EASY_SCORE) {
          return 'Easy';
        }
        if (score === _constants.Constants.GOOD_SCORE) {
          return 'Good';
        }
        return 'Hard';
      };
      _this.updateSpacedRepetitionFields = function () {
        var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var data = {
          last_score: _this.card.lastScore,
          views_count: _this.card.viewsCount,
          easiness_factor: _this.card.easinessFactor,
          repetition_interval: _this.card.repetitionInterval,
          review_after: _this.card.reviewAfter ? _this.card.reviewAfter.toString() : null,
          consecutive_good_scores: _this.card.consecutiveGoodScores,
          had_positive_score: _this.card.hadPositiveScore
        };
        _state.DeckUI.cardStore.update({
          data: data,
          ids: {
            cardId: _this.card.id
          }
        }, reload ? _this.loadCard : null);
      };
      _this.onChangeCardTypeId = function (id) {
        var _this$card5, _this$card6;
        (_this$card5 = _this.card) === null || _this$card5 === void 0 || _this$card5.set('cardTypeId', id);
        (_this$card6 = _this.card) === null || _this$card6 === void 0 || _this$card6.set('cardTypeName', _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.id === id;
        }).name);
        _this.cardTypeName = _this.card.cardTypeName;
        _state.DeckUI.cardStore.update({
          data: {
            card_type_id: id
          },
          ids: {
            cardId: _this.card.id
          }
        }); //, this.loadCard);
        _this.showUpdatedCardTypeMessage = true;
      };
      _this.onSwitchBackToCustom = function () {
        _this.onChangeCardTypeId(_constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.slug === 'user_submission';
        }).id);
      };
      _this.setShowChartDetails = function (showChartDetails) {
        _this.showChartDetails = showChartDetails;
      };
      _this.toggleIntervalTesterReviewsDueAtBeginningOfDay = function () {
        _this.intervalTesterReviewsDueAtBeginningOfDay = !_this.intervalTesterReviewsDueAtBeginningOfDay;
      };
      _this.onUpdateFrontText = function (value) {
        _this.syncCardText('frontText', value);
      };
      _this.onUpdateBackText = function (value) {
        _this.syncCardText('backText', value);
      };
      _this.onSwapFrontAndBack = function () {
        var frontText = _this.card.frontText;
        var backText = _this.card.backText;
        _this.onUpdateFrontText(backText);
        _this.onUpdateBackText(frontText);
        _state.DeckUI.cardStore.update({
          data: {
            front_text: backText,
            back_text: frontText
          },
          ids: {
            cardId: _this.card.id
          }
        });
      };
      _state.AppUI.reviewStore.clearIndexData();
      _this.currentCardId = _this.cardId;
      _this.ensureCardLoaded();
      if (_this.card) {
        _this.cardTypeName = _this.card.cardTypeName;
      }
      _this.resetIntervalTester();
      return _this;
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "hasLoadedIntervalTesterCard",
      value: function hasLoadedIntervalTesterCard(card) {
        return Boolean(card && typeof card.cloneForReviewSimulation === 'function' && typeof card.formattedReviewInterval === 'function');
      }
    }, {
      key: "loadedCard",
      get: function get() {
        var _AppUI$cardStore$show3;
        if (this.cardId && cardIdsMatch((_AppUI$cardStore$show3 = _state.AppUI.cardStore.showData) === null || _AppUI$cardStore$show3 === void 0 ? void 0 : _AppUI$cardStore$show3.id, this.cardId)) {
          return _state.AppUI.cardStore.showData;
        }
        return null;
      }
    }, {
      key: "fallbackCard",
      get: function get() {
        var _this2 = this;
        if (this.props.card) {
          return this.props.card;
        }
        if (this.cardId) {
          var _AppUI$cardStore$inde;
          var indexCard = (_AppUI$cardStore$inde = _state.AppUI.cardStore.indexData) === null || _AppUI$cardStore$inde === void 0 ? void 0 : _AppUI$cardStore$inde.find(function (item) {
            return cardIdsMatch(item.id, _this2.cardId);
          });
          if (indexCard) {
            return indexCard;
          }
        }
        if (_state.DeckUI.layout.isNative) {
          return _state.DeckUI.currentCard;
        }
        return null;
      }
    }, {
      key: "card",
      get: function get() {
        if (this.loadedCard) {
          return this.loadedCard;
        }
        if (this.cardId && !this.hasLoadedIntervalTesterCard(this.fallbackCard)) {
          return null;
        }
        return this.fallbackCard;
      }
    }, {
      key: "cardId",
      get: function get() {
        var _this$props$route;
        if ((_this$props$route = this.props.route) !== null && _this$props$route !== void 0 && (_this$props$route = _this$props$route.params) !== null && _this$props$route !== void 0 && _this$props$route.cardId) {
          var _this$props$route2;
          return (_this$props$route2 = this.props.route) === null || _this$props$route2 === void 0 || (_this$props$route2 = _this$props$route2.params) === null || _this$props$route2 === void 0 ? void 0 : _this$props$route2.cardId;
        } else if (this.props.card) {
          return this.props.card.id;
        } else if (this.props.cardId) {
          return this.props.cardId;
        } else if (_state.DeckUI.currentCard) {
          return _state.DeckUI.currentCard.id;
        }
      }
    }, {
      key: "showChart",
      get: function get() {
        return !_state.AppUI.loadingReviews && _state.AppUI.reviewStore.hasIndexData && _state.AppUI.reviewStore.indexData.length > 1;
      }
    }, {
      key: "chartWidth",
      get: function get() {
        return _state.DeckUI.layout.innerDeckWidth;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.cardStore.clearShowData();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var currentCardId = this.cardId;
        if (prevProps.card !== this.props.card || !cardIdsMatch(this.currentCardId, currentCardId)) {
          this.currentCardId = currentCardId;
          this.retireReviewPending = false;
          this.ensureCardLoaded();
          if (this.card) {
            this.cardTypeName = this.card.cardTypeName;
          }
          this.resetIntervalTester();
        }
      }
    }, {
      key: "reviewProgressRows",
      get: function get() {
        var reviewRows = _state.AppUI.reviewStore.indexData.filter(function (item) {
          return (0, _utils.isPresent)(item.repetitionInterval);
        });
        return [].concat(_toConsumableArray(this.testReviewRows), _toConsumableArray(reviewRows));
      }
    }, {
      key: "simulationCard",
      value: function simulationCard(card) {
        if (this.hasLoadedIntervalTesterCard(card)) {
          return card.cloneForReviewSimulation();
        }
        return null;
      }
    }, {
      key: "hasEditableCardType",
      get: function get() {
        return (0, _utils.isPresent)(this.card) && ['vocab_word_comprehend', 'vocab_word_options', 'vocab_word_translate', 'vocab_sentence_comprehend', 'comprehend', 'translate'].includes(this.card.cardTypeSlug);
      }
    }, {
      key: "showSwapFrontAndBack",
      get: function get() {
        return Boolean(this.card && this.card.cardTypeSlug === 'user_submission' && (0, _utils.isPresent)(this.card.frontText) && (0, _utils.isPresent)(this.card.backText));
      }
    }, {
      key: "reviewAfterText",
      get: function get() {
        var _this$card7, _AppUI$user2;
        return (0, _review_due_helpers.formatReviewAfterText)((_this$card7 = this.card) === null || _this$card7 === void 0 ? void 0 : _this$card7.reviewAfter, (_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.reviewsDueAtBeginningOfDay);
      }
    }, {
      key: "isReviewPastDue",
      get: function get() {
        var _this$card8, _AppUI$user3;
        return (0, _review_due_helpers.reviewIsPastDue)((_this$card8 = this.card) === null || _this$card8 === void 0 ? void 0 : _this$card8.reviewAfter, (_AppUI$user3 = _state.AppUI.user) === null || _AppUI$user3 === void 0 ? void 0 : _AppUI$user3.reviewsDueAtBeginningOfDay);
      }
    }, {
      key: "showExactReviewAfter",
      get: function get() {
        var _AppUI$user4;
        return (0, _review_due_helpers.showExactReviewAfter)((_AppUI$user4 = _state.AppUI.user) === null || _AppUI$user4 === void 0 ? void 0 : _AppUI$user4.reviewsDueAtBeginningOfDay);
      }
    }, {
      key: "intervalTesterCard",
      get: function get() {
        return this.testCard || this.card;
      }
    }, {
      key: "currentRepetitionIntervalText",
      get: function get() {
        var _AppUI$user5, _this$intervalTesterC;
        var reviewsDueAtBeginningOfDayValue = _state.AppUI.layout.isNative ? (_AppUI$user5 = _state.AppUI.user) === null || _AppUI$user5 === void 0 ? void 0 : _AppUI$user5.reviewsDueAtBeginningOfDay : this.intervalTesterReviewsDueAtBeginningOfDay;
        var repetitionInterval = (0, _review_due_helpers.roundedRepetitionInterval)((_this$intervalTesterC = this.intervalTesterCard) === null || _this$intervalTesterC === void 0 ? void 0 : _this$intervalTesterC.repetitionInterval, reviewsDueAtBeginningOfDayValue);
        return "".concat(repetitionInterval, " Day").concat(repetitionInterval === 1 ? '' : 's');
      }
    }, {
      key: "setCardText",
      value: function setCardText(card, field, value) {
        if (card !== null && card !== void 0 && card.set) {
          card.set(field, value);
        }
      }
    }, {
      key: "syncCardText",
      value: function syncCardText(field, value) {
        var _this3 = this,
          _AppUI$cardStore$inde2;
        if (!this.cardId) {
          return;
        }
        var cards = [];
        var addCard = function addCard(card) {
          if (card && cardIdsMatch(card.id, _this3.cardId) && !cards.includes(card)) {
            cards.push(card);
          }
        };
        addCard(this.card);
        addCard(this.props.card);
        addCard(_state.AppUI.cardStore.showData);
        addCard((_AppUI$cardStore$inde2 = _state.AppUI.cardStore.indexData) === null || _AppUI$cardStore$inde2 === void 0 ? void 0 : _AppUI$cardStore$inde2.find(function (item) {
          return cardIdsMatch(item.id, _this3.cardId);
        }));
        addCard(_state.DeckUI.currentCard);
        _state.DeckUI.animationCards.forEach(function (item) {
          return addCard(item.card);
        });
        cards.forEach(function (card) {
          return _this3.setCardText(card, field, value);
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          card: this.card,
          cardId: this.cardId,
          showChart: this.showChart,
          onSnoozeReview: this.onSnoozeReview,
          onResetReview: this.onResetReview,
          onDeleteReview: this.onDeleteReview,
          onRetireReview: this.onRetireReview,
          onSwitchBackToCustom: this.onSwitchBackToCustom,
          onChangeCardTypeId: this.onChangeCardTypeId,
          processScore: this.processScore,
          intervalTesterCard: this.intervalTesterCard,
          intervalTesterReviewsDueAtBeginningOfDay: this.intervalTesterReviewsDueAtBeginningOfDay,
          onToggleIntervalTesterReviewsDueAtBeginningOfDay: this.toggleIntervalTesterReviewsDueAtBeginningOfDay,
          testReviewRows: this.testReviewRows,
          reviewProgressRows: this.reviewProgressRows,
          currentRepetitionIntervalText: this.currentRepetitionIntervalText,
          chartWidth: this.chartWidth,
          setShowChartDetails: this.setShowChartDetails,
          showSpinner: this.showSpinner,
          showChartDetails: this.showChartDetails,
          forceReviewAfterDue: this.forceReviewAfterDue,
          showUpdatedCardTypeMessage: this.showUpdatedCardTypeMessage,
          hasEditableCardType: this.hasEditableCardType,
          showSwapFrontAndBack: this.showSwapFrontAndBack,
          cardTypeName: this.cardTypeName,
          onSwapFrontAndBack: this.onSwapFrontAndBack,
          onUpdateFrontText: this.onUpdateFrontText,
          onUpdateBackText: this.onUpdateBackText,
          reviewAfterText: this.reviewAfterText,
          isReviewPastDue: this.isReviewPastDue,
          showExactReviewAfter: this.showExactReviewAfter,
          reviewActionConfirmTitle: REVIEW_ACTION_CONFIRM_TITLE,
          reviewActionConfirmMessage: REVIEW_ACTION_CONFIRM_MESSAGE,
          retireReviewPending: this.retireReviewPending
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showChartDetails", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "forceReviewAfterDue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showUpdatedCardTypeMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "retireReviewPending", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cardTypeName", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "testReviewRows", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "testCard", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "intervalTesterReviewsDueAtBeginningOfDay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "loadedCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loadedCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fallbackCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "fallbackCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "card", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "card"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showChart", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chartWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "chartWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewProgressRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewProgressRows"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasEditableCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasEditableCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSwapFrontAndBack", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSwapFrontAndBack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewAfterText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewAfterText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReviewPastDue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReviewPastDue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExactReviewAfter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showExactReviewAfter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "intervalTesterCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "intervalTesterCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentRepetitionIntervalText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentRepetitionIntervalText"), _class.prototype), _class));
};
ReviewDetailsWrapper.displayName = 'ReviewDetailsWrapper';
var _default = exports["default"] = ReviewDetailsWrapper;